import { useRef, useState } from "react";
import api from "@/lib/api";
import { Button } from "@/components/ui/button";
import { toast } from "sonner";
import { Upload, Loader2, FileText, X } from "lucide-react";

/**
 * kind: "photo" | "logo" | "certificate"
 * onUploaded: (fileMeta) => void
 * accept: file input accept string
 * preview: existing URL to show as preview (photo/logo only)
 */
export default function FileUpload({ kind, onUploaded, preview, accept, label = "Carica file", testId }) {
    const [busy, setBusy] = useState(false);
    const ref = useRef(null);

    const pick = () => ref.current?.click();

    const onChange = async (e) => {
        const file = e.target.files?.[0];
        if (!file) return;
        setBusy(true);
        try {
            const fd = new FormData();
            fd.append("file", file);
            const { data } = await api.post(`/upload?kind=${kind}`, fd, {
                headers: { "Content-Type": "multipart/form-data" },
            });
            toast.success("Caricato");
            onUploaded?.(data.data);
        } catch (err) {
            toast.error(err.response?.data?.detail || "Errore upload");
        } finally {
            setBusy(false);
            if (ref.current) ref.current.value = "";
        }
    };

    const previewUrl = preview ? (preview.startsWith("http") ? preview : `${process.env.REACT_APP_BACKEND_URL}${preview}`) : null;

    return (
        <div className="flex items-center gap-4" data-testid={testId}>
            {(kind === "photo" || kind === "logo") && (
                <div className="w-20 h-20 rounded-lg bg-[#F9F9F7] border border-[#E5E5E0] overflow-hidden grid place-items-center">
                    {previewUrl ? (
                        <img src={previewUrl} alt="preview" className="w-full h-full object-cover" />
                    ) : (
                        <FileText className="w-6 h-6 text-[#A3A3A3]" />
                    )}
                </div>
            )}
            <div>
                <input ref={ref} type="file" className="hidden"
                    accept={accept || (kind === "certificate" ? ".pdf,.jpg,.jpeg,.png" : ".jpg,.jpeg,.png,.webp")}
                    onChange={onChange} data-testid={`${testId}-input`} />
                <Button type="button" variant="outline" onClick={pick} disabled={busy} data-testid={`${testId}-btn`}>
                    {busy ? <Loader2 className="w-4 h-4 mr-2 animate-spin" /> : <Upload className="w-4 h-4 mr-2" />}
                    {label}
                </Button>
                <p className="text-xs text-[#5C5C5C] mt-1">
                    {kind === "certificate" ? "PDF o immagine, max 8MB" : "JPG/PNG/WEBP, max 8MB"}
                </p>
            </div>
        </div>
    );
}
